export class AppUtil {
    static addTrailingSlash(url: string): string {
        if (!url) {
            return '';
        }
        if (url.endsWith('/')) {
            return url;
        }
        return url + '/';
    }
}
